import React from 'react'
import PropTypes from 'prop-types'
import {Redirect, useLocation} from 'react-router-dom'
import {useCustomer, useCustomerId} from '@salesforce/commerce-sdk-react'
import {AbsoluteCenter, Spinner} from '@chakra-ui/react'

const RouteGuard = ({
    children,
    redirectTo = '/login',
    loadingComponent: LoadingComponent = null
}) => {
    const location = useLocation()
    const customerId = useCustomerId()

    const {data: customer, isLoading} = useCustomer(
        {parameters: {customerId}},
        {enabled: !!customerId}
    )

    if (isLoading) {
        return LoadingComponent ? (
            <LoadingComponent />
        ) : (
            <AbsoluteCenter>
                <Spinner />
            </AbsoluteCenter>
        )
    }

    const isAuthenticated = customer?.authType === 'registered'

    if (!isAuthenticated) {
        return (
            <Redirect
                to={{
                    pathname: redirectTo,
                    state: {from: location}
                }}
            />
        )
    }

    return children
}

RouteGuard.propTypes = {
    children: PropTypes.node.isRequired,
    redirectTo: PropTypes.string,
    loadingComponent: PropTypes.elementType
}

export default RouteGuard
